import './tropicalweddings/style';
import FormStructure from './tropicalweddings/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js